import EpharmLogo from '../components/epharm-logo';

function NotFound() {
  return (
    <div>
      <EpharmLogo />
      <div
        style={{
          height: '62vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <h2>Page not found</h2>
        <p
          style={{
            margin: 0,
            color: '#00000099',
          }}
        >
          Let's get you back on track -
          <a href="https://epharmni.com/" className="links" style={{ marginLeft: '4px' }}>
            ePharmNI Homepage
          </a>
        </p>
      </div>
    </div>
  );
}

export default NotFound;
